module.exports = __webpack_public_path__ + "img/pencil.c81a3a10.svg";